import { render, staticRenderFns } from "./AIChat_Questions.vue?vue&type=template&id=4177b97e&scoped=true"
import script from "./AIChat_Questions.vue?vue&type=script&lang=js"
export * from "./AIChat_Questions.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Questions.vue?vue&type=style&index=0&id=4177b97e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177b97e",
  null
  
)

export default component.exports